export default __webpack_public_path__ + "21cf51e369b0bcb2fa838c59af097e99.png";